import { setIdPlayer } from '../utils/users';
import requestApi from './request_api';

export const playerRequests = {
    getPlayers: async () => {
        const res = await requestApi('/players/get', 'get', {});
        return res.data;
    },
    getPlayer: (id) => {},
    createPlayer: async (player) => {
        const res = await requestApi('/players/create', 'post', {
            input: {
                pseudo: player.pseudo,
                score: 0,
            }
        });

        if(res.data.success){
            setIdPlayer(res.data.data.id);
        }

        return res.data;
    },

    updatePlayer: async (player) => {
        const res = await requestApi('/players/update', 'post', {
            input: {
                id: player.id,
                score: player.score,
            }
        });

        return res.data;
    },

    deletePlayer: (id) => {
        return requestApi('/players/delete', 'post', {
            input: {
                id: id,
            }
        });
    },
};

export const gameRequests = {
    getQuestions: async () => {
        const res = await requestApi('/questions/get', 'get', {});
        return res.data;
    },

    createQuestion: async (title, city, tip) => {
        const res = await requestApi('/questions/create', 'post', {
            input: {
                title: title,
                city: city,
                tip: tip,
            }
        });
        return res.data;
    },

    updateQuestion: async (id, title, city, tip) => {
        const res = await requestApi('/questions/update', 'post', {
            input: {
                id: id,
                title: title,
                city: city,
                tip: tip
            }
        });
        return res.data;
    },

    deleteQuestion: async (id) => {
        const res = await requestApi('/questions/delete', 'post', {
            input: {
                id: id,
            }
        });
        return res.data;
    },

    createResponse: async (question_id, title) => {
        const res = await requestApi('/questions_responses/create', 'post', {
            input: {
                question_id: question_id,
                title: title,
            }
        });
        return res.data;
    },

    deleteResponse: async (id) => {
        const res = await requestApi('/questions_responses/delete', 'post', {
            input: {
                id: id,
            }
        });
        return res.data;
    },

    updateResponse: async (id, title, is_correct) => {
        const res = await requestApi('/questions_responses/update', 'post', {
            input: {
                id: id,
                title: title,
                is_correct: is_correct,
            }
        });
        return res.data;
    },
};